import React, { memo } from 'react';
import { Route, Routes } from 'react-router-dom';
import SpecificationsDashboard from 'containers/Specifications';
import SpecificationDetails from 'containers/Specifications/SpecificationDetails/SpecificationDetails';
import SpecificationDocument from 'views/SpecificationDocument';
function SpecificationsRouts() {
    return (React.createElement(Routes, null,
        React.createElement(Route, { path: "details/:modelSpecificationId/*", element: React.createElement(SpecificationDetails, null) }),
        React.createElement(Route, { path: "pdf-components/:modelSpecificationId", element: React.createElement(SpecificationDocument, { includeComponents: true }) }),
        React.createElement(Route, { path: "pdf/:modelSpecificationId", element: React.createElement(SpecificationDocument, null) }),
        React.createElement(Route, { path: "*", element: React.createElement(SpecificationsDashboard, null) })));
}
export default memo(SpecificationsRouts);
